import { Component, OnInit } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InsuranceService } from '../Services/insurance-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InsuranceIssuanceBaseData, UnitedPassengersBaseProperties } from '../Models/TravelInsuranceProperties';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';

@Component({
    selector: 'app-travel-insurance-booking',
    templateUrl: './travel-insurance-booking.component.html',
    styleUrls: ['./travel-insurance-booking.component.css'],
    imports: [NavMenuComponent, FormsModule]
})
export class TravelInsuranceBookingComponent implements OnInit {

  constructor(private router: Router, private insuranceService: InsuranceService, private NewSuccess: NgbModal, private route: ActivatedRoute) { }
  routeid: string | null = null;
  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.routeid = params.get('id');
    });
    if (this.routeid === '00') {
      this.isUnited = false;
    } else if (this.routeid === '11') {
      this.isUnited = true;
    }
  }
  PNR: string = "";
  showPolicy: boolean = false;
  showUnitedPolicy: boolean = false;
  isUnited: boolean = false;
  notUnited: boolean = false;
  baseData: InsuranceIssuanceBaseData = new InsuranceIssuanceBaseData();
  unitedBaseData: UnitedPassengersBaseProperties = new UnitedPassengersBaseProperties();
  SearchBookedPlans(form: NgForm) {
    this.PNR = form.value.pnr;
    this.insuranceService.GetPolicyDetails(this.PNR).subscribe(data => {
      this.baseData = data;
      this.showPolicy = true;
      this.showUnitedPolicy = false;
    });
  }
  SearchBookedPlansUnited(form: NgForm) {
    this.insuranceService.GetPolicyDetailsUnited(form.value.policyNo).subscribe((data) => {
      this.unitedBaseData = data;
      this.showPolicy = false;
      this.showUnitedPolicy = true;
    });
  }
  ToDashboard() {
    this.showPolicy = false;
    this.router.navigateByUrl('insurance');
  }
  openTraveler(model: NgbModal) {
    this.NewSuccess.open(model, {
      backdrop: 'static',
      size: 'lg',
      centered: true
    })
  }
  openTravelerUnited(model: NgbModal) {
    this.NewSuccess.open(model, {
      backdrop: 'static',
      size: 'lg',
      centered: true
    })
  }
  
}
